/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_Q6Inputs */

const en_to_csv_faq_q6 = /** @type {(inputs: To_Csv_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does Excel show my Korean or accented text as garbage?`)
};

const ko_to_csv_faq_q6 = /** @type {(inputs: To_Csv_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel에서 한글이나 악센트 문자가 왜 깨져 보이나요?`)
};

const ja_to_csv_faq_q6 = /** @type {(inputs: To_Csv_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel で日本語やアクセント付き文字が文字化けするのはなぜですか`)
};

/**
* | output |
* | --- |
* | "Why does Excel show my Korean or accented text as garbage?" |
*
* @param {To_Csv_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_q6 = /** @type {((inputs?: To_Csv_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_q6(inputs)
	if (locale === "ko") return ko_to_csv_faq_q6(inputs)
	return ja_to_csv_faq_q6(inputs)
});